import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory, createHashHistory } from "history";
import App from "./containers/App";
import createStore from "./redux/createStore";
import Moment from "moment";
import momentLocalizer from "react-widgets-moment";

Moment.locale("en");
momentLocalizer();

const history = window.matchMedia("(display-mode: standalone)").matches
  ? createHashHistory()
  : createBrowserHistory();
const store = createStore(history, {});

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById("root"),
);
